import { addToPresentation } from 'viewSettings/exportHandlers';
import { ViewIds } from '@ardoq/api-types';
import { getExportsForSvgView } from '@ardoq/export';
import { getExportLabels } from 'views/getExportLabels';
import { getRightMenuConfig as getRightMenu } from '../../viewSettings/getRightMenuConfig';
import { trackExportingVisualization } from '../../tracking/events/visualizations';
import { getStyleSheets } from '../getSharedExportFunctions';
import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import type { OnViewSettingsUpdate } from '@ardoq/data-model';
import { SpiderChartViewSettings } from './types';
import type { I18nLocale } from '@ardoq/i18n';

type GetRightMenuArgs = {
  viewSettings: SpiderChartViewSettings;
  getContainer: () => Element | null;
  viewId: ViewIds;
  isEmptyView: boolean;
  onViewSettingsUpdate: OnViewSettingsUpdate;
  i18nLocale: I18nLocale;
};

export const getRightMenuConfig = ({
  viewSettings,
  getContainer,
  viewId,
  isEmptyView,
  onViewSettingsUpdate,
  i18nLocale,
}: GetRightMenuArgs) => {
  const exports = getExportsForSvgView({
    container: getContainer,
    exportedViewMetadata: {
      name: viewId,
      isViewpointMode: false,
    },
    trackingFunction: trackExportingVisualization,
    addToPresentation,
    getStyleSheets,
    labels: getExportLabels(i18nLocale),
  });

  return [
    ...getRightMenu({
      isViewpointMode: false,
      viewId,
      viewstate: viewSettings,
      exports: {
        exportToPng: exports.exportToPng,
        addToPresentation: exports.addToPresentation,
        isDisabled: isEmptyView,
      },
      knowledgeBaseLink: KnowledgeBaseLink.SPIDER_CHART,
      isLegendDisabled: isEmptyView,
      onViewSettingsUpdate,
      i18nLocale,
    }),
  ];
};
